import { COLOR_NEUTRAL, COLOR_NEUTRAL_DARK, COLOR_NEUTRAL_LIGHT, COLOR_NEUTRAL_ULTRALIGHT } from '../colors.constants';

export const colorsTimer = {
  colorTimerBackground: COLOR_NEUTRAL_ULTRALIGHT,
  colorTimer: COLOR_NEUTRAL_DARK,
  colorTimerTitle: COLOR_NEUTRAL,
  colorTimerBorder: COLOR_NEUTRAL_LIGHT,
};
